// removed by extract-text-webpack-plugin
module.exports = {"absolute-center":"onfido-sdk-ui-Spinner-absolute-center","loader":"onfido-sdk-ui-Spinner-loader","inner":"onfido-sdk-ui-Spinner-inner","ball-scale-ripple-multiple":"onfido-sdk-ui-Spinner-ball-scale-ripple-multiple"};


//////////////////
// WEBPACK FOOTER
// ./components/Spinner/style.css
// module id = 385
// module chunks = 1